<template>
    <div class="konfiguratorItem__product">
        <div class="product-select-gallery"
             :class="!inBasket ? 'product-select-gallery-dynamic' : ''">
            <type-image-gallery
                :type-id="variantId"
                :images="galleryImages">
            </type-image-gallery>
        </div>

        <div class="konfiguratorRow" :class="{'is-disabled' : inBasket, 'is-active': showBottom }" :id="product.uid">

            <div class="row mb-1">
                <div class="col">
                    <div class="lead-text mb-2 mb-md-0">{{ typeText }}</div>
                </div>
                <div class="col text-right" v-if="!fixed">
                    <button class="remove-cross" @click="openConfirmDeletePopup"></button>
                </div>
            </div>

            <div
                class="konfiguratorRow__inputs"
                :class="{'row' : fixed}"
                :data-type="typeCode"
                :data-parameter-count="product.parameters.filter(isNotHiddenParam).length"
            >
                <div v-if="fixed && paramsVariantDoesNotExist" class="col-auto mr-1 mb-2 mb-md-0">
                    <span class="description">{{ tpValue }}</span>
                </div>
                <sheet-variant-select
                    v-if="groupCode !== currentCollectionType && groupCode === 'sheet'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1086, colorHashId: 1090, sizeId: 1078, colorNameCreator: (item) => item.colorName + ' ' + item.fabric}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'decorative_pillows'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1092, colorHashId: 1094, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'plaids_and_bedspreads'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1093, colorHashId: 1095, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'topper'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1110, colorHashId: 1111, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'textile_bags'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1097, colorHashId: 1098, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'towel'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1099, colorHashId: 1100, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <sheet-variant-select
                    v-else-if="groupCode === 'bathroom_mats'"
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextWithPrefix)"
                    :config="{colorId: 1103, colorHashId: 1105, sizeId: 1078, colorNameCreator: (item) => item.colorName}"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />
                <variant-select
                    v-else
                    :fixed="fixed"
                    :group-code="groupCode"
                    :params-variant-does-not-exist="paramsVariantDoesNotExist"
                    :type-code="typeCode"
                    :product="product"
                    :type-text="toLowerCaseByDomain(typeTextInflection)"
                    :variant-id="variantId"
                    @input="changeTPValue"
                    @changeImage="changeImage"
                />

                <div class="js-konfigurator-how-to-mesure-desktop-wrap text-right text-md-left" v-if="renderMeasurePopup">
                    <a href="#" @click.prevent="showHowToMeasurePopup = true"
                       class="js-konfigurator-how-to-mesure-btn konfiguratorRow__howToMeasure link-underline link-underline--gray text-transform-initial">{{ renderMeasureText }}</a>
                </div>

                <div class="d-none d-md-block">
                    <product-counter
                        v-if="!fixed"
                        @input="setQuanitity"
                        v-model="product.quantity"
                        :allow-zero="true"
                        :max-value="storeQuantity"
                        :use-max-value="inBasket"
                        :allow-overgrow="!inBasket"
                        increment-message="Více toho na skladu nemáme"
                        @overgrow="showOvergrowPopup"
                        @change="processingChange"
                    ></product-counter>
                </div>

                <!-- Desktop version of counter -->
                <div class="col-auto mr-1 text-md-center" v-if="fixed && !paramsVariantDoesNotExist">
                    <product-counter
                        @input="setQuanitity"
                        v-model="product.quantity"
                        :allow-zero="true"
                        :max-value="storeQuantity"
                        :use-max-value="inBasket || !isStored"
                        :allow-overgrow="!inBasket && isStored"
                        increment-message="Více toho na skladu nemáme"
                        @overgrow="showOvergrowPopup"
                        @change="processingChange"
                    ></product-counter>
                </div>
                <div class="col-auto mr-1 text-md-center" v-if="fixed && paramsVariantDoesNotExist">
                    <product-counter
                        v-model="nullQuantity"
                        :allow-zero="true"
                        :max-value="0"
                        :use-max-value="inBasket || !isStored"
                        :allow-overgrow="false"
                        increment-message="Více toho na skladu nemáme"
                        @overgrow="showOvergrowPopup"
                        @change="processingChange"
                    ></product-counter>
                </div>
                <div class="col-6 col-md-2 text-right pr-md-0" v-if="fixed && isStored">
                <span class="price-value"
                      v-if="paramsSelectionNotConcreteEnough">{{ $t('components.ProductSelect.basket') }}</span>
                    <span class="price-value" v-if="paramsVariantDoesNotExist"></span>
                    <div class="price-value" v-else>
                        <span :class="{ 'price-value--stroke mr-1' : priceAction !== null }"
                              v-text="$nf(price, 'currency' + currencyCode, 'cs-CZ')"
                        />

                        <span v-if="priceAction"
                              v-text="$nf(priceAction, 'currency' + currencyCode, 'cs-CZ')"
                        />

                    </div>
                </div>

                <div class="col-md-4 ml-auto text-right" v-if="fixed">
                    <button class="btnCart  mt-2 mt-md-0"
                            :class="{'is-loading' : isLoading, 'is-adding': isAdding, 'is-added' : inBasket}"
                            v-if="!paramsSelectionNotConcreteEnough && !paramsVariantDoesNotExist && !hideCartButton"
                            @click.prevent.stop="toBasket">
                        <svg class="btnCart__ico">
                            <use xlink:href="#cart"></use>
                        </svg>
                        <span class="btnCart__text">{{ cartButtonText }}</span>
                    </button>
                </div>
                <div v-if="fixed" :class="(!isStored || notEnough) ? 'col-12 mt-1' : 'col-12 mt-1'">
                    <div class="d-md-flex w-100 mb-3 mb-md-0 align-items-center">
                        <span class="stock" :class="{'not-enough-stock' : !isStored || notEnough}">{{ storeText }}</span>
                        <div class="note-small ml-3 mx-md-2 letter-spacing-lg mb-2 mb-md-0" v-if="!isStored">{{
                                noStoreHint
                            }}
                        </div>
                        <button class="ml-3 ml-md-auto btn btn--smallAlt btn--small text-uppercase"
                                @click.prevent.stop="showWatchDogPopup" v-if="!isStored">Hlídat dostupnost
                        </button>
                    </div>
                </div>
            </div>
            <confirm-delete-popup
                @confirm="submitDelete"
                @cancel="closeConfirmDeletePopup"
                :show="showConfirmPopup"
                :inBasket="inBasket"
                :message="inBasket ? $t('components.ConfirmDeletePopup.title') : $t('components.ConfirmDeletePopup.titleNotInBasket')"
            ></confirm-delete-popup>
            <info-popup
                :show="showOvergrow"
                :title="$t('common.notInStock')"
                :message="$t('common.overgrow')"
                :button="$t('common.close')"
                @cancel="closeOvergrowPopup"
            ></info-popup>
            <watch-dog-popup
                :show="showWatchDog"
                :title="variantName"
                :button="$t('common.close')"
                :variantId="variantId"
                @cancel="closeWatchDogPopup"
            ></watch-dog-popup>
            <div v-if="isChanging && !showBottom" class="row loading"></div>
            <vue-slide-up-down v-if="!fixed" class="row konfiguratorRow__bottom align-items-center"
                               :class="{'loading' : isChanging}" :active="showBottom" :duration="200">

                <div :class="(!isStored || notEnough) ? 'col-8' : 'col-4'">
                    <div class="d-md-flex w-100 align-items-center">
                    <span class="stock" v-if="!paramsSelectionNotConcreteEnough && !paramsVariantDoesNotExist"
                          :class="{'not-enough-stock' : !isStored || notEnough}">{{ storeText }}</span>
                        <div class="note-small ml-3 mx-md-2 letter-spacing-lg" v-if="!isStored">{{ noStoreHint }}</div>


                    </div>
                </div>
                <!-- Mobile version of counter -->
                <div class="col-4 d-md-none text-center px-0">
                    <product-counter
                        v-if="!fixed"
                        @input="setQuanitity"
                        v-model="product.quantity"
                        :allow-zero="true"
                        :max-value="storeQuantity"
                        :use-max-value="inBasket"
                        :allow-overgrow="!inBasket"
                        increment-message="Více toho na skladu nemáme"
                        @overgrow="showOvergrowPopup"
                        @change="processingChange"
                    ></product-counter>
                </div>

                <div v-if="!isStored" class="col-12 mt-2 mt-md-0 col-md-4 text-center text-md-right">
                    <button class="ml-md-auto btn btn--smallAlt btn--small text-uppercase"
                            @click.prevent.stop="showWatchDogPopup">{{ $t('components.ProductSelect.watchDog') }}
                    </button>
                </div>

                <div class="col-4 text-right pr-md-3">
                <span class="price-value"
                      v-if="paramsSelectionNotConcreteEnough">{{ $t('components.ProductSelect.basket') }}</span>
                    <span class="price-value" v-if="paramsVariantDoesNotExist || hideCartButton"></span>
                    <div class="price-value" v-else>

                        <span :class="{ 'price-value--stroke mr-1' : priceAction !== null }"
                              v-text="$nf(price, 'currency' + currencyCode, 'cs-CZ')"
                        />

                        <span v-if="priceAction"
                              v-text="$nf(priceAction, 'currency' + currencyCode, 'cs-CZ')"
                        />

                    </div>
                </div>


                <div class="col-12 col-md-4 mt-2 mt-md-0 text-right">
                    <button class="btnCart"
                            :class="{'is-loading' : isLoading, 'is-adding': isAdding, 'is-added' : inBasket}"
                            v-if="!paramsSelectionNotConcreteEnough && !paramsVariantDoesNotExist && !hideCartButton"
                            @click.prevent.stop="toBasket">
                        <svg class="btnCart__ico">
                            <use xlink:href="#cart"></use>
                        </svg>
                        <span class="btnCart__text">{{ cartButtonText }}</span>
                    </button>
                </div>
            </vue-slide-up-down>
            <how-to-measure-popup :show="showHowToMeasurePopup" :type-code="typeCode"
                                  @cancel="showHowToMeasurePopup = false"
                                  @confirm="showHowToMeasurePopup = false"></how-to-measure-popup>
        </div>
    </div>
</template>

<script>

import ProductCounter from "./ProductCounter";
import ConfirmDeletePopup from "./ConfirmDeleteConfPopup";
import InfoPopup from "@/components/InfoPopup";
import WatchDogPopup from "@/components/WatchDogPopup";
import VariantSelect from "./VariantSelect";
import SheetVariantSelect from "./SheetVariantSelect";
import TypeImageGallery from "@/components/TypeImageGallery";

export default {
    components: {
        SheetVariantSelect,
        VariantSelect,
        WatchDogPopup,
        InfoPopup,
        ConfirmDeletePopup,
        ProductCounter,
        TypeImageGallery,
    },
    props: {
        product: {},
        fixed: {
            default: false,
            type: Boolean
        },
        typeCode: {
            default: '',
            type: String
        },
        groupCode: {
            default: '',
            type: String
        }
    },
    data: function () {
        return {
            showCustomDimensionsPopup: false,
            showConfirmPopup: false,
            showOvergrow: false,
            isAdding: false,
            isLoading: false,
            isChanging: false,
            processing: false,
            sendToBasket: false,
            nullQuantity: 1,
            showWatchDog: false,
            showHowToMeasurePopup: false,
            test: null,
            galleryImages: [],
        }
    },
    computed: {
        variants() {
            return this.$store.getters.getVariantsForType(this.product.type);
        },
        currentCollectionId() {
            return this.$store.getters.currentCollectionId;
        },
        currentCollectionType() {
            return this.$store.getters.currentCollectionType;
        },
        price: function () {
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length > 1) {
                throw this.$t('components.ProductSelect.narrowDownSelection');
            } else if (variants.length < 1) {
                throw ''; //Produkt se zadanými požadavky nemáme
            } else {
                let variant = variants[0];
                let price = variant.price.priceWithVat * this.product.quantity;
                return price;
            }
        },
        priceAction: function () {
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length > 1) {
                throw this.$t('components.ProductSelect.narrowDownSelection');
            } else if (variants.length < 1) {
                throw ''; //Produkt se zadanými požadavky nemáme
            } else {
                let variant = variants[0];
                if (!variant.priceAction){
                    return null;
                }
                return variant.priceAction.priceWithVat * this.product.quantity;
            }
        },
        isStored: function () {
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length !== 1) {
                return false;
            } else {
                let variant = variants[0];
                return variant.isStored;
            }
        },
        renderMeasureText: function () {
            if (this.groupCode === 'bathrobe') {
                return this.$t('components.TypePack.howToMeasure.bathrobe.bathrobe');
            }

            return this.$t('components.TypePack.howToMeasure.simple');
        },
        renderMeasurePopup: function () {
            let renderMeasurePopup = false;
            if (this.groupCode === 'cover') {
                renderMeasurePopup = ['duvet', 'pillow'].includes(this.typeCode)
            } else {
                renderMeasurePopup = ['bathrobe', 'sheet'].includes(this.typeCode)
            }
            return renderMeasurePopup;
        },
        notEnough: function () {
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length !== 1) {
                return false;
            } else {
                let variant = variants[0];
                return variant.isStored && variant.storeQuantity < this.quantity;
            }
        },
        storeQuantity: function () {
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length !== 1) {
                return 0;
            } else {
                let variant = variants[0];
                return variant.storeQuantity;
            }
        },
        cartButtonText: function () {
            if (this.inBasket) {
                return this.$t('components.ProductSelect.inBasket');
            }
            if (this.isAdding) {
                return '';
            }
            return this.$t('components.ProductSelect.addToBasket');
        },
        inBasket: function () {
            return this.product.inBasket;
        },
        hideCartButton: function () {
            return !this.inBasket && this.storeQuantity < this.quantity
        },
        quantity: function () {
            return this.product.quantity;
        },
        storeText: function () {
            if (!this.isStored || this.notEnough) {
                if (this.noStoreStateName) {
                    return this.noStoreStateName;
                }
                return this.$t('components.ProductSelect.notInStock');
            }
            return this.$t('components.ProductSelect.inStock');
        },
        noStoreStateName: function () {
            let variant = this.getVariant(this.product);
            return variant ? variant.noStoreStateName : false;
        },
        noStoreHint: function () {
            let variant = this.getVariant(this.product);
            return variant ? variant.noStoreHint : false;
        },
        variantName: function () {
            let variant = this.getVariant(this.product);
            return variant ? variant.variantName : false;
        },
        variantId: function () {
            let variant = this.getVariant(this.product);
            return variant ? variant.variantId : false;
        },
        showBottom() {
            if (this.fixed) {
                return this.isStored;
            }
            return this.$store.getters.getVariantsFor(this.product).length === 1;
        },
        paramsSelectionNotConcreteEnough: function () {
            if (this.product.isCustom) {
                return false;
            }
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length > 1) {
                return true;
            }
            return false;
        },
        paramsVariantDoesNotExist: function () {
            if (this.product.isCustom) {
                return false;
            }
            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length < 1) {
                return true;
            }
            return false;
        },
        currency: function () {
            if (this.product.isCustom) {
                const customPrice = this.product.customPrice;
                return customPrice.currency.htmlString;
            }

            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length > 0) {
                return variants[0].price.currency.htmlString;
            }
            throw 'Unknown currency';
        },
        currencyCode: function () {
            if (this.product.isCustom) {
                const customPrice = this.product.customPrice;
                return customPrice.currency.code;
            }

            var variants = this.$store.getters.getVariantsFor(this.product);
            if (variants.length > 0) {
                return variants[0].price.currency.code;
            }
            throw 'Unknown currency';
        },
        customIsSelected: function () {
            if (typeof this.product.customParameters == 'undefined') {
                return false;
            }
            if (this.product.customParameters.length > 0) {
                return true; //TODO
            }
            return false;
        },
        typeText: function () {
            let typeText = '';

            if (this.product.type == 3 && this.$store.getters.typeGroups.indexOf('filling') < 0) {
                typeText = this.$t('components.ProductSelect.type.pillow');
            } else if (this.product.type == 4 && this.$store.getters.typeGroups.indexOf('filling') < 0) {
                typeText = this.$t('components.ProductSelect.type.duvet');
            } else {
                typeText = this.$t('components.ProductSelect.itemTypeId.' + this.product.type);
            }

            return typeText;
        },
        typePrefix: function () {
            let typePrefix = '';

            if (this.product.type == 3 && this.$store.getters.typeGroups.indexOf('filling') < 0) {
                typePrefix = this.$t('components.ProductSelect.typePrefix.cover.pillow');
            } else if (this.product.type == 4 && this.$store.getters.typeGroups.indexOf('filling') < 0) {
                typePrefix = this.$t('components.ProductSelect.typePrefix.cover.duvet');
            } else {
                typePrefix = this.$t('components.ProductSelect.itemTypePrefixId.' + this.product.type);
            }

            return typePrefix.trim();
        },
        typeTextWithPrefix: function () {
            let typeText = this.typeText;
            let typePrefix = this.typePrefix;

            if (typePrefix){
                return typePrefix + ' ' + typeText;
            }

            return typeText;
        },
        typeTextInflection: function () {
            let typeText = '';
            let inflection = this.$te('components.ProductSelect.itemTypeIdInflection.' + this.product.type);
            if (inflection) {
                typeText = this.$t('components.ProductSelect.itemTypeIdInflection.' + this.product.type);
            }else{
                typeText = this.typeText;
            }

            let typePrefix = this.typePrefix;

            if (typePrefix){
                return typePrefix + ' ' + typeText;
            }

            return typeText;
        },
    },
    watch: {
        inBasket(newVal) {
            if (!newVal) {
                this.isAdding = false;
            } else {
                this.updateSideBasket();
            }
        },
        quantity: function () {
            if (this.inBasket) {
                this.updateSideBasket();
            }
        }
    },
    methods: {
        selectVariant(id) {
            if (!id) {
                return;
            }
            var variant = this.$store.getters.getVariantById(id);
            this.changeTPValue(
                {
                    values: variant.technicalParameters.map(function (tp) {
                        return {
                            tpId: tp.id,
                            value: typeof tp.value.value == "boolean" ? tp.value.value : tp.value.id
                        }
                    })
                })
        },
        getVariant: function (product) {
            var variants = this.$store.getters.getVariantsFor(product);
            if (variants.length !== 1) {
                return false;
            }

            return variants[0];
        },
        remove: function () {
            var vm = this;
            this.$store.dispatch('removeItem', {uid: this.product.uid}).then(function () {
                vm.updateSideBasket();
            });
        },
        processingChange() {
            this.processing = true;
        },
        toBasket: function () {
            this.isLoading = true;
            if (this.processing) {
                this.sendToBasket = true;
                return;
            }
            var vm = this;

            if (typeof window.fbq === 'function') {
                let fbqData = {
                    content_name: this.product.name,
                    content_ids: [this.product.uid],
                    content_type: 'product'
                };
                window.fbq('track', 'AddToCart', fbqData);
                //console.log(['track', 'AddToCart', fbqData]);
            }

            this.$store.dispatch('addConfiguratorItemToBasket', {uid: this.product.uid})
                .then(function () {
                    vm.isLoading = false;
                    vm.isAdding = true;
                });
        },
        changeTPValue: function (payload) {
            var vm = this;
            this.isChanging = true;
            this.$store.dispatch('changeTPValue', {
                uid: this.product.uid,
                values: payload.values
            }).finally(function () {
                vm.$nextTick(function () {
                    vm.isChanging = false;
                });
            })
        },
        changeImage: function (payload) {
            this.galleryImages = [payload];
        },
        setQuanitity: function (value) {
            if (value <= 0) {
                this.openConfirmDeletePopup();
            } else {
                var vm = this;
                this.$store.dispatch('changeProductQuantity', {
                    uid: this.product.uid,
                    quantity: value
                }).then(function () {
                    vm.processing = false;
                    if (vm.sendToBasket) {
                        vm.sendToBasket = false;
                        vm.toBasket()
                    } else {
                        vm.updateSideBasket();
                    }
                });
            }

        },
        updateSideBasket() {
            if (this.inBasket) {
                window.$('#basket-update').trigger('click');
            }
        },
        changeCustomDimensions: function (payload) {
            this.$store.dispatch('changeCustomDimensions', {
                uid: this.product.uid,
                values: payload.values
            });
        },
        getDimensions(product) {
            let dimensions = {
                width: null,
                height: null
            };
            if ('customParameters' in product) {
                product.customParameters.forEach(customParam => {
                    if (customParam.type == 'type-dimensions') {
                        dimensions = customParam.value;
                    }
                });
            }
            return dimensions;
        },
        isNotHiddenParam(param) {
            return param.type !== 'hidden';
        },
        openConfirmDeletePopup() {
            this.showConfirmPopup = true;
        },
        submitDelete() {
            this.showConfirmPopup = false;
            this.remove();
        },
        closeConfirmDeletePopup() {
            this.showConfirmPopup = false;
            this.product.quantity = 1;
        },
        showOvergrowPopup() {
            this.showOvergrow = true;
        },
        closeOvergrowPopup() {
            this.showOvergrow = false;
        },
        showWatchDogPopup() {
            this.showWatchDog = true;
        },
        closeWatchDogPopup() {
            this.showWatchDog = false;
        },
        toLowerCaseByDomain(value) {
            if (this.$store.getters.localeTag === 'de-DE') {
                return value;
            }

            return value.toLowerCase();
        },
    },
    created() {
        var image = this.$store.getters.variantImage(this.variantId, this.product.type);

        if (!image) {
            this.galleryImages = [];
            return;
        }

        this.galleryImages = [{
            preview: image.preview,
            big: image.big,
        }];
    }
}
</script>

<style>
.product-select-gallery {
    /* text-align: right; */
}

.product-select-gallery img {
    /* transition: all 1s ease-in-out; */
}

.product-select-gallery:not(.product-select-gallery-dynamic) img {
    /* height: 130px;
    width: auto; */
}
</style>
